import React from 'react';
import PropTypes from 'prop-types';
import {Star} from '@spothero/icons';
import {Icon, Text, Box, useBreakpointValue} from '@spothero/ui';

function StarRating({spot}) {
    const numberOfRatings = spot?.facility?.common?.rating?.count;
    const averageRating = spot?.facility?.common?.rating?.average;
    const numberOfStars = Math.ceil(averageRating);
    const arrayOfStars = Array(Math.ceil(numberOfStars)).fill('star');
    const displayRating = averageRating.toFixed(1);
    const isMobile = useBreakpointValue({mobileXL: false, base: true});

    return (
        <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            height=".75rem"
            paddingTop=".75rem"
            paddingBottom=".25rem"
            marginY={{mobileXL: '.5rem', base: '.25rem'}}
        >
            {isMobile ? (
                <Icon as={Star} title="star" color="warning" />
            ) : (
                arrayOfStars.map((star, i) => {
                    return (
                        <Icon as={Star} key={i} title="star" color="warning" />
                    );
                })
            )}
            <Text
                fontSize=".75rem"
                fontWeight="semibold"
                paddingX=".25rem"
            >{` ${displayRating}`}</Text>
            <Text
                fontSize=".75rem"
                color="gray"
                paddingX=".125rem"
            >{` (${numberOfRatings})`}</Text>
        </Box>
    );
}

StarRating.propTypes = {
    spot: PropTypes.object,
};

export default StarRating;
